// Imports
import { PortalContext } from 'src/modules/01 Global/jsx/contexts.jsx';
import { Timeline } from 'src/modules/my-research-timeline/jsx/component.jsx';
import { ResearchSection } from 'src/modules/my-research/jsx/research-section.jsx';


// Stateless components

export function MyResearchPage(props) {

    function renderPageContent(context) {
        
        return (
            <div className="my-research__wrapper">
                <Timeline />
                <ResearchSection />
            </div>
        );
    }


    //
    // Render
    //

    return (
        <PortalContext.Consumer>
            {renderPageContent}
        </PortalContext.Consumer>
    );

};
